<template>
  <div class="upload_image">
    <div class="__upload-image" v-loading="isLoading">
      <el-image ref="img" :src="'/api'+value" fit="cover" :preview-src-list="['/api'+value]">
        <div slot="error" class="error_img">
          <div style="color:#f11;margin-top:50%;">近期1寸<br/>电子彩照</div>
        </div>
      </el-image>
      <div class="__image-buttons" v-if="value">
        <i class="el-icon-zoom-in" @click="onPreview"></i>
        <el-popconfirm title="确定删除吗？" v-if="showDel" @confirm="onDelete">
          <i class="el-icon-delete" slot="reference" style="margin-left:10px"></i>
        </el-popconfirm>
      </div>
    </div>
    <div class="upload_btn" :style="isMB?'margin: 15px 0 10px':''">
      <el-upload
        :headers="header"
        :action="uploadUrl"
        :before-upload="beforePhotoUpload"
        :on-success="onUploadSuccess"
        :show-file-list="false"
        accept=".jpg,.png,.jpeg"
        :data="data"
      >
        <el-button size="mini" style="width: 130px;" type="primary" icon="el-icon-upload2">上传照片</el-button>
      </el-upload>
    </div>
    <el-dialog
      append-to-body
      title="截取照片"
      ref="dialog"
      :width="isMB?'100%':'500px'"
      class="img-cropper"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
    >
      <div class="cropper-w">
        <div class="cropper" :style="{ width: '100%', height: '360px' }">
          <vueCropper
            ref="cropper"
            :img="option.img"
            :outputSize="option.size"
            :outputType="option.outputType"
            :info="option.info"
            :full="option.full"
            :canMove="option.canMove"
            :canMoveBox="option.canMoveBox"
            :original="option.original"
            :autoCrop="option.autoCrop"
            :autoCropWidth="option.autoCropWidth"
            :autoCropHeight="option.autoCropHeight"
            :fixedBox="option.fixedBox"
          ></vueCropper>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <span v-if="!isMB" style="float:left;font-size:16px;">滚动鼠标进行缩放</span>
        <el-button type="primary" @click="finish">确 认</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import api from "@/api/po/junior6";
import api2 from "@/api/po/junior9";
import { VueCropper } from 'vue-cropper';

export default {
  components: {
  VueCropper,
  },
  props: {
    value: {
      type: String,
      default: undefined,
    },
    deleteFunc: {
      type: Function,
      default: api.deletePhoto,
    },
    type: {
      type: String,
      default: undefined,
    },
    data: {
      type: Object,
      default: null,
    },
    showDel: {
      type: Boolean,
      default: true,
    },
    IsDetail: {
      type: Boolean,
      default: false,
    },
    tip: {
      type: String,
      default: "",
    },
    ut: {
      type: Number,
      default: 6,
    },
    uploadUrl: {
      type: String,
      default: api.uploadPicture,
    },
  },
  data() {
    return {
      isLoading: false,
      dialogVisible:false,
       option: {
        img: "", // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: "jpg", // 裁剪生成图片的格式
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 128, // 默认生成截图框宽度
        autoCropHeight: 163, // 默认生成截图框高度
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: false, // 是否开启截图框宽高固定比例
        fixedNumber: [7, 5], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: true, // 截图框能否拖动
        original: true, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },
      isMB: this.$store.state.isMB,
    };
  },
  computed: {
    header() {
      let token6 = localStorage.getItem("token6");
      if (token6) {
        return { Authorization: "Bearer " + token6 };
      }
      return {};
    },
  },
  methods: {
    onUploadSuccess(res, file, fileList) {
      if(res.Code==0) {
        this.$emit("input", "" + res.Data);
      } else this.$message.error(res.Msg);
    },
    onDelete() {
      this.$emit("input", "");
    },
    beforePhotoUpload(file) {
      let self = this
      const _URL = window.URL || window.webkitURL
      const image = new Image();
      image.src = _URL.createObjectURL(file);
      self.option.img = ''
      image.onload = function () {
        let base64 = self.transBase64FromImage(image);
        self.option.img = base64
      }
      this.picWidth = 1200
      this.dialogVisible = true;
      return false;
    },
    transBase64FromImage(image) {
      let canvas = document.createElement("canvas");
      canvas.width = image.width;
      canvas.height = image.height;
      let ctx = canvas.getContext("2d");
      ctx.drawImage(image, 0, 0, image.width, image.height);
      // 可选其他值 image/jpeg
      return canvas.toDataURL("image/png");
    },
    // base64转成files
    transformToFiles(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    finish() {
		  let _this = this
		  this.$refs.cropper.getCropBlob(async (data) => {
      let formData = new FormData();
      if(data){
              var timestamp = new Date().getTime() + '.jpg'
          //  将blob格式转换为文件。File() 构造器创建新的 File 对象实例。
          const newFile = new window.File([data], timestamp);

          // formData.append('file',newFile)
          //调用axios上传
          //----------------------------
          var _this = this;
          return new Promise((resolve, reject) => {
            try {
              var reader = new FileReader();
              // 将文件加载进入
              reader.readAsDataURL(newFile);
              reader.onload = function (e) {
                var base64 = reader.result;
                console.log("原", (base64.length * 0.75) / 1024);
                _this.dealImage(base64, function (new_base64) {
                  console.log("后", (new_base64.length * 0.75) / 1024);
                  var new_file = _this.dataURLtoFile(new_base64, newFile.name);
                  console.log("new_file", new_file);
                  formData.append('file',new_file)
                  var p = _this.ut==6?api:api2;
                  p.uploadPic(formData).then(res => {
                    if(res.Code==0) {
                      _this.onUploadSuccess(res);
                      _this.dialogVisible = false
                    } else _this.$message.error(res.Msg);
                  })
                });
              };
            } catch (error) {
              reject(error);
            }
          });
          //----------------------------
        } else {
          this.$message.warning('请重新截图')
        }
      })
      _this.$forceUpdate()
    },
    dealImage(base64, callback) {
      var newImage = new Image();
      var quality = 1; //压缩系数0-1之间
      newImage.src = base64;
      newImage.setAttribute("crossOrigin", 'Anonymous'); //url为外域时需要
      var imgWidth, imgHeight;
      newImage.onload = function() {
        imgWidth = this.width;
        imgHeight = this.height;
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        if (imgWidth > 1080 || imgHeight > 1080) {
          if (imgHeight > imgWidth) {
            canvas.height = 1080;
            var ratio = imgWidth / imgHeight;
            canvas.width = canvas.height * ratio;
          } else {
            canvas.width = 1080;
            var ratio = imgWidth / imgHeight;
            canvas.height = canvas.width / ratio;
          }
        } else {
          canvas.width = imgWidth;
          canvas.height = imgHeight;
        }
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(this, 0, 0, canvas.width, canvas.height);
        var base64 = canvas.toDataURL("image/jpeg", quality); //压缩语句
        // console.log("??!-*",base64.length)
        // 如想确保图片压缩到自己想要的尺寸,如要求在50-150kb之间，请加以下语句，quality初始值根据情况自定
        while (base64.length *0.75 / 1024 > 200) {
        	quality -= 0.1;
        	base64 = canvas.toDataURL("image/jpeg", quality);
          // console.log("压缩")
        }
        callback(base64); //必须通过回调函数返回，否则无法及时拿到该值
      }
    },
    dataURLtoFile (dataurl, filename) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    onPreview() {
      this.$refs.img.clickHandler();
    },
  },
};
</script>

<style lang="scss">
.upload_image {
  width: 100%;
  .__upload-area {
    border: 1px dashed #c0ccda;
    // border-radius: 6px;
    box-sizing: border-box;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    line-height: 120px;
    width: 120px;
    height: 120px;
    font-size: 32px;
    color: #8c939d;
  }
  .__upload-area:hover {
    border-color: #409eff;
  }
  .__upload-image {
    border: 1px solid #c0ccda;
    overflow: hidden;
    width: 130px;
    height: 165px;
    margin: auto;
    position: relative;
    .el-image {
      width: 100%;
      height: 100%;
      // object-fit: cover;
    }
    // .error_img {
    //   font-size: 96px;
    //   text-align: center;
    //   padding-top: 23px;
    //   color: #959595;
    // }
    .__image-buttons {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      bottom: 0;
      opacity: 0;
      background: rgba(0, 0, 0, 0.5);
      line-height: 165px;
      color: #ffffff;
      transition: opacity 0.3s;
      text-align: center;
      i {
        font-size: 18px;
        cursor: pointer;
      }
      i + i {
        margin-left: 10px;
      }
    }
    .__image-buttons:hover {
      opacity: 1;
    }
  }
}

.upload_btn {
  width: 100%;
  text-align: center;
  margin-top: 6px;
}
</style>